/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Controller } from 'react-hook-form';
import { Skeleton } from '@mui/material';
import {
  FormDialog,
  FormDialogActions,
  FormDialogContent,
  FormDialogTitle,
  FormElement,
  FormInputsStack,
  FormSubmissionError,
  FormCancelButton,
  Inputs,
  InputPhone,
  InputSkeleton,
  TimezoneSelector,
  getFieldProps,
  getSubmitButtonProps,
} from '@marageti/z4-lib';
import { LoadingButton } from '@mui/lab';
import { ViewProps } from './types';
import { validatePhone } from '../../../utils/helpers/validation';

const EditUserFormView = ({
  control,
  errors,
  handleSubmit,
  isSubmitting,
  isValid,
  open,
  onCancel,
  onSubmit,
  register,
  submissionError,
  teamMember,
}: ViewProps) => (
  <FormDialog
    open={open}
  >
    <FormDialogTitle handleClose={onCancel}>
      {teamMember?.fullName
        ? `Edit ${teamMember?.fullName}`
        : <Skeleton variant="rounded" />}
    </FormDialogTitle>
    <FormElement name="profile-editor-form" onSubmit={handleSubmit(onSubmit)}>
      <FormDialogContent>
        {!teamMember ? (
          <FormInputsStack>
            <InputSkeleton key="First Name" />
            <InputSkeleton key="Last Name" />
            <InputSkeleton key="email" />
            <InputSkeleton key="phone" />
            <InputSkeleton key="timeZone" />
          </FormInputsStack>
        ) : (
          <FormInputsStack>
            {submissionError
              && (
                <FormSubmissionError
                  message={submissionError.message}
                  errorCode={submissionError.code}
                  errorId={submissionError.id}
                />
              )}
            <Inputs.Text
              defaultValue={teamMember?.givenName}
              error={!!errors?.givenName}
              helperText={errors?.givenName?.message as string}
              id="givenName"
              label="First Name"
              required
              {...register('givenName', { required: 'Please enter a first name' })}
            />
            <Inputs.Text
              defaultValue={teamMember?.familyName}
              error={!!errors?.familyName}
              helperText={errors?.familyName?.message as string}
              id="familyName"
              label="Last Name"
              required
              {...register('familyName', { required: 'Please enter a last name' })}
            />
            <Controller
              control={control}
              defaultValue={teamMember?.phone}
              name="phone"
              render={({ field }) => (
                <InputPhone
                  error={!!errors.phone}
                  id="phone"
                  helperText={errors.phone ? 'Please enter a valid phone number' : ''}
                  label="Phone"
                  {...field}
                />
              )}
              rules={{ validate: validatePhone }}
            />
            <Controller
              control={control}
              defaultValue={teamMember.timeZone}
              name="timeZone"
              render={({ field }) => (
                <TimezoneSelector
                  id="timeZone-selector"
                  label="Timezone"
                  {...getFieldProps('timeZone', errors)}
                  {...field}
                />
              )}
            />
          </FormInputsStack>
        )}
      </FormDialogContent>
      <FormDialogActions>
        <FormCancelButton onClick={onCancel} />
        <LoadingButton
          variant="contained"
          type="submit"
          {...getSubmitButtonProps(isSubmitting, isValid)}
        >
          Submit
        </LoadingButton>
      </FormDialogActions>
    </FormElement>
  </FormDialog>
);

export default EditUserFormView;
